import { useIntl } from "react-intl";
import Markdown from "react-markdown";

export const Text = () => {
  const { formatMessage } = useIntl();

  return (
    <section>
      <div className="container mx-auto">
        <div className="flex justify-center">
          <div className="w-full">
            <div className="mb-8">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-2 text-2xl" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_TITLE",
                })}
              </Markdown>
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-8" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT",
                })}
              </Markdown>
              <Markdown
                components={{
                  li: ({ children, ...rest }) => (
                    <li className="flex items-start gap-3 mb-6" {...rest}>
                      <span className="w-3 h-3 rounded-full bg-primary-light flex-shrink-0 mt-2" />
                      <span className="flex-1">{children}</span>
                    </li>
                  ),
                  ul: ({ children, ...rest }) => (
                    <ul className="list-none" {...rest}>
                      {children}
                    </ul>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_2",
                })}
              </Markdown>
            </div>
            <div className="mb-8">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-2 text-2xl" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_TITLE_2",
                })}
              </Markdown>
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-8" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_3",
                })}
              </Markdown>
              <Markdown
                components={{
                  li: ({ children, ...rest }) => (
                    <li className="flex items-start gap-3 mb-6" {...rest}>
                      <span className="w-3 h-3 rounded-full bg-primary-light flex-shrink-0 mt-2" />
                      <span className="flex-1">{children}</span>
                    </li>
                  ),
                  ul: ({ children, ...rest }) => (
                    <ul className="list-none" {...rest}>
                      {children}
                    </ul>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_4",
                })}
              </Markdown>
            </div>
            <div className="">
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-2 text-2xl" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_TITLE_3",
                })}
              </Markdown>
              <Markdown
                components={{
                  p: ({ children, ...rest }) => (
                    <p className="mb-8" {...rest}>
                      {children}
                    </p>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_5",
                })}
              </Markdown>
              <Markdown
                components={{
                  li: ({ children, ...rest }) => (
                    <li className="flex items-start gap-3 mb-6" {...rest}>
                      <span className="w-3 h-3 rounded-full bg-primary-light flex-shrink-0 mt-2" />
                      <span className="flex-1">{children}</span>
                    </li>
                  ),
                  ul: ({ children, ...rest }) => (
                    <ul className="list-none" {...rest}>
                      {children}
                    </ul>
                  ),
                }}
              >
                {formatMessage({
                  id: "GUIDE_FOR_EXPERT_TEXT_6",
                })}
              </Markdown>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
